import React from 'react'
import RegisterConfirmationCard from '@/components/RegisterConfirmationCard/RegisterConfirmationCard';

const RegisterConfirmation: React.FC = () => {

    React.useEffect(() => {
        window.scroll({ top: 0, left: 0, behavior: 'auto' })
    }, []);

    return (
        <RegisterConfirmationCard />
    )
}

export default RegisterConfirmation
